import { parse as cookieParse, serialize as cookieSerialize } from 'cookie';
import { strollers_api_v2_reviews_photos_get_url } from 'mk/urls/functions';
import {
    strollerAllReviewsPhotosFetchApi,
    strollerAllReviewsPhotosUpdateThumbs,
    StrollerAllReviewsPhotosCheckHideThumbsAction,
    StrollerAllReviewsPhotosFetchNormalizedResponse,
    StrollerAllReviewsPhotosFetchTriggerAction,
    StrollerAllReviewsPhotosToggleThumbsTriggerAction,
    STROLLER_ALL_REVIEWS_PHOTOS_CHECK_HIDE_THUMBS,
    STROLLER_ALL_REVIEWS_PHOTOS_FETCH_TRIGGER,
    STROLLER_ALL_REVIEWS_PHOTOS_TOGGLE_THUMBS_TRIGGER,
} from 'mk2/apps/strollers/containers/StrollerAllReviewsPhotos/StrollerAllReviewsPhotos.actions';
import {
    STROLLER_ALL_REVIEWS_PHOTOS_HIDE_THUMBNAILS_COOKIE,
} from 'mk2/apps/strollers/containers/StrollerAllReviewsPhotos/StrollerAllReviewsPhotosPage';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { all, call, delay, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('strollers/StrollerAllReviewsPhotos.sagas');

const getStrollerPhotosHideThumbnailsCookie = (): boolean => {
    if (typeof window !== 'undefined') {
        return cookieParse(document.cookie)[STROLLER_ALL_REVIEWS_PHOTOS_HIDE_THUMBNAILS_COOKIE] === String(true) || false;
    }
    return false;
};

interface FetchApiResponse {
    body: StrollerAllReviewsPhotosFetchNormalizedResponse;
}

function* fetchStrollerReviews({ strollerSlug, xhr }: StrollerAllReviewsPhotosFetchTriggerAction & XHRAction) {
    yield put(strollerAllReviewsPhotosFetchApi.request(strollerSlug));

    try {
        const response: FetchApiResponse = yield call(
            () => xhr.get(strollers_api_v2_reviews_photos_get_url({strollerSlug})),
        );

        yield put(strollerAllReviewsPhotosFetchApi.success(strollerSlug, response.body));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(strollerAllReviewsPhotosFetchApi.failure(strollerSlug, normalizeError(error)));
    }
}


function* toggleThumbs({ xhr }: StrollerAllReviewsPhotosToggleThumbsTriggerAction & XHRAction) {
    const currentValue = getStrollerPhotosHideThumbnailsCookie();

    // when changing showThumbnails then the ImageGalleryLoadable need to be unmounted and re-rendered (to avoid buggy
    // behaviour of showThumbnail) */}
    yield put(strollerAllReviewsPhotosUpdateThumbs(null));
    yield delay(500);

    const newValue = !currentValue;
    document.cookie = cookieSerialize(STROLLER_ALL_REVIEWS_PHOTOS_HIDE_THUMBNAILS_COOKIE, String(newValue), {
        path: '/',
    });
    yield put(strollerAllReviewsPhotosUpdateThumbs(newValue));
}

function* checkHideThumbs({ xhr }: StrollerAllReviewsPhotosCheckHideThumbsAction & XHRAction) {
    const currentValue = getStrollerPhotosHideThumbnailsCookie();
    yield put(strollerAllReviewsPhotosUpdateThumbs(currentValue));
}

export default function* root() {
    yield all([
        takeLatest(STROLLER_ALL_REVIEWS_PHOTOS_FETCH_TRIGGER, fetchStrollerReviews),
        takeLatest(STROLLER_ALL_REVIEWS_PHOTOS_TOGGLE_THUMBS_TRIGGER, toggleThumbs),
        takeLatest(STROLLER_ALL_REVIEWS_PHOTOS_CHECK_HIDE_THUMBS, checkHideThumbs),
    ]);
}
